import script from "./QuotationDetailPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuotationDetailPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuotationDetailPage.vue?vue&type=style&index=0&id=bd16452e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd16452e"]])

export default __exports__